import { put, takeLatest, call } from 'redux-saga/effects'
import { fetchNotifications, updateNotifications } from '@/core/apiModules/notifications'
import { notificationsModule } from '../modules'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* fetch({ payload }) {
  try {
    const response = yield call(fetchNotifications, payload.memberId)
    yield put(notificationsModule.fetchSuccess(response))
  } catch (err) {
    yield call(errorHandler, err)
  }
}

function* update({ payload }) {
  try {
    const response = yield call(updateNotifications, payload.memberId, payload.params)
    yield put(notificationsModule.updateSuccess(response))
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* notificationsSaga() {
  yield takeLatest(notificationsModule.FETCH, fetch)
  yield takeLatest(notificationsModule.UPDATE, update)
}
